import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router'
import { fetchAuthSession } from 'aws-amplify/auth'

@Injectable({
  providedIn: 'root'
})
export class NavigationContextGuard {
  reload: boolean = false
  constructor (private router: Router) {}

  async canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (this.reload && state.url === '/server-error') {
      this.reload = false
      return true
    }
    if (state.url === '/server-error') {
      this.reload = true
      const session = await fetchAuthSession()
      if (session?.tokens?.idToken) {
        return this.router.parseUrl('/dashboard')
      } else {
        this.router.navigate(['/login-initiate'])
        return false
      }
    } else {
      this.router.navigate(['/login-initiate'])
      return false
    }
  }
}
